<template>
  <van-popup v-model="showPicker" round :position="position" :style="{ height: '70%',width: '100%' }">
    <van-row>
      <van-col span="24">
        <div style="width: 100%;text-align: center;padding: 5px 0px 5px 0px">
          <span>{{title}}</span>
        </div>
      </van-col>
      <van-col span="24" style="">
        <div style="height: 300px;overflow:auto">
          <van-checkbox-group v-model="checks" style="height: 300px">
            <van-cell-group inset>
              <van-cell v-for="(item, index) in columns" clickable :key="'cellxq'+index"
                        :title="item.text == '(请选择)' ? '(全部)' : item.text" @click="toggle(item)">
                <template #right-icon>
                  <van-checkbox :name="(item.value == '' ? 'qb' : item.value)+'|'+item.text" ref="checkboxes" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </div>
      </van-col>
    </van-row>

    <div width="100%" style="padding: 20px 0px 50px 0px" >
      <van-button type="info" style="width: 50%" @click="onCancel">取消</van-button>
      <van-button type="info" style="width: 49%;float: right" @click="onConfirm">确定</van-button>
    </div>

  </van-popup>
</template>

<script>
  export default {
    name: "comchoiceall",
    props: {
      //标题
      title: {
        type: String,
        default: ''
      },
      //弹出方向
      position: {
        type: String,
        default: 'bottom'
      },
      //类型
      type: {
        type: String,
        default: ''
      },
      //字段
      zd: {
        type: String,
        default: ''
      },
      //内容
      nr: {
        type: String,
        default: ''
      },
      callbak: {
        type: Function,
        default: null,
      }

    },
    data() {
      return {
        showPicker:false,
        value:null,
        text:null,
        columns:[],
        dm:null,

        checks:[],
      }
    },
    created() {
    },
    methods: {
      show(show,dm,method){
        this.showPicker = show;
        this.dm = dm;
        this.getlist();
      },
      getlist(){
        let that = this;
        let datas = {
          type:that.type,
          zd:that.zd,
          nr:that.nr,
        };
        this.$ajax.post('/appapi/appcom/choicelx',datas).then(function (rep) {
          if (rep.code == 200) {
            that.columns = rep.columnsList;
          }
        });
      },
      onConfirm() {
        for(let i = 0;i < this.value.split(',').length;i++){
          if(this.value.split(',')[i] == 'qb'){
            this.checks = [];
            this.value = '';
            this.text = '(全部)';
            break;
          }
        }
        this.callbak(this.value,this.text);
        this.showPicker = false;
      },
      onCancel() {
        this.showPicker = false;
      },
      toggle(item){
        let index = this.checks.indexOf((item.value == '' ? 'qb' : item.value)+'|'+item.text);
        if (index > -1) {//大于0 代表存在，
          this.checks.splice(index, 1);//存在就删除
        } else {
          this.checks.push((item.value == '' ? 'qb' : item.value)+'|'+item.text);
        }
        let ret = '',dms = '',mcs = '';
        for(let i = 0;i < this.checks.length;i++){
          dms = dms + this.checks[i].split('|')[0]+',';
          mcs = mcs + this.checks[i].split('|')[1]+',';
        }
        if(dms.length > 0){
          dms = dms.substring(0,dms.length-1);
          mcs = mcs.substring(0,mcs.length-1);
        }
        this.value = dms;
        this.text = mcs;
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/choice/comchoiceall.vue